import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizationService } from '../../Services/localization-service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found-component',
  imports: [
    TranslatePipe
  ],
  templateUrl: './not-found-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './not-found-component.scss'
})
export class NotFoundComponent {
  private readonly router = inject(Router);
  private readonly localizationService = inject(LocalizationService);

  goHome(): void {
    const currentLang = this.localizationService.getCurrentLang();
    this.router.navigate([`/${currentLang}`]);
  }

  goBack(): void {
    window.history.back();
  }
}
